import React from 'react';
const ProgressBar = require('react-progress-bar-plus');
import ReactLoading from 'react-loading';
require('react-progress-bar-plus/lib/progress-bar.css');


import NonUpdateFragment from './NonUpdateFragment';


const withProgressBar = function (TargetForm) {


  return class extends React.Component {

    constructor(props) {
      super(props);

      this.state = {
        progress: 0,
      };

    }

    updateProgressBar = (progress) => {
      this.setState({
        progress: progress
      });
    }

    render() {
      return (
        <React.Fragment>
          <NonUpdateFragment progress={this.state.progress}>

            <TargetForm {...this.props}
              ref={(input) => {
                this.nameInput = input;
              }}
              updateProgressBar={this.updateProgressBar}
            />
          </NonUpdateFragment>
          <ProgressBar percent={this.state.progress} autoIncrement={this.state.progress > 0} spinner={false} intervalTime={100} />
          {this.state.progress > 0 && this.state.progress < 100 && <div
          className="popupContainer" tabIndex="-1">

          <div style={{ position: 'fixed', top: '50%', left: '50%', marginLeft: '-40px', marginTop: '-50px' }}>
            <ReactLoading
              type="bars" color="#20a8d8" height={100} width={80} />
          </div>
        </div>}
        </React.Fragment>
      );
    }

  }

}

export default withProgressBar;



// WEBPACK FOOTER //
// ./src/components/withProgressBar.js